import React, {useMemo} from 'react';
import TableTasksSingleVoyages from "@containers/singleVoyage/tasks/table/TableTasksSingleVoyages";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import Box from '@mui/material/Box';
import {
    useSaveTaskMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/tasks/hooks/useSaveTaskMutateSingleVoyage";
import {
    useDeleteTaskMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/tasks/hooks/useDeleteTaskMutateSingleVoyage";

interface IProps {
    closeModalFn?: () => void
}

const MutateTasksMutateSingleVoyage = ({closeModalFn}: IProps) => {
    const {
        tasks,
        points,
        accountId,
    } = useRootContextMutateSingleVoyage()

    const {
        onSaveTask,
        isLoading,
        isFetching
    } = useSaveTaskMutateSingleVoyage({
        accountId,
    })

    const {onDelete} = useDeleteTaskMutateSingleVoyage()

    const waypointsWidthPlannedOrdinal = useMemo(() => {
        return points.map((point, index) => {
            return {
                ...point,
                plannedOrdinal: index
            }
        })
    }, [points])


    if (isFetching || isLoading) {
        return (
            <SpinnerCustom
                variant={'fullScreen'}
            />
        )
    }
    return (
        // ModalCustom centers its content vertically - in fullscreen mode that left
        // the table floating in the middle of an empty screen. Stretch to full height
        // so the content starts at the top.
        <Box
            sx={{
                width: '100%',
                // flex:1 rather than height:100% - the modal's parent container has no
                // definite height, so the percentage resolves to auto.
                flex: 1,
                minHeight: 0,
                alignSelf: 'stretch',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                overflowY: 'auto',
                padding: {xs: '0 12px', lg: '0 24px'},
            }}
        >
            <TableTasksSingleVoyages
                voyageId={0}
                waypoints={waypointsWidthPlannedOrdinal}
                tasks={tasks}
                onSave={onSaveTask}
                onDelete={onDelete}
                accountId={accountId}

            />
        </Box>
    );
};

export default MutateTasksMutateSingleVoyage;
